import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { MessageService } from 'primeng/api';
import { BenefitcalculatorService } from './benefitcalculator.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class UtilityFunctionService {
    resultTime: any;
    constructor(
        private benefitCalculatorService: BenefitcalculatorService,
        private messageService: MessageService
    ) { }
    
    // Function to convert a number to currency format
    public formatCurrency(value: number): string {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    // Function to convert string to title case
    public toTitleCase(str: string): string {
        return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    }


    // Function to get the current date and time in the specified format
    public getCurrentDateTime(): string {
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            // timeZoneName: 'short'
        };
        return new Date().toLocaleString('en-US', options);

        
    }
    // Function to generate EST date and time hide AM / PM
    public getESTDateTime(): string {
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'America/New_York',
            hour12: false
        };
        return new Date().toLocaleString('en-US', options);
    }
    // Function to generate UTC date and time

    redirectUserAnnuityNexus(productId: number, productType: string): void {
        let loginSessionData = JSON.parse(sessionStorage.getItem('logInSession') || '');
        let logindata = this.benefitCalculatorService.decryptUsingAES256(loginSessionData);
        const loginUserData = JSON.parse(logindata);
        let mainMenuBtnLink = 'https://staging.an.annuitynexus.com/auth?token=';
        if (environment.domain == 'https://benefitapi.annuitynexus.com') {
            mainMenuBtnLink = 'https://an.annuitynexus.com/auth?token=';
        }
        this.benefitCalculatorService.getUser(loginUserData.id).pipe(take(1)).subscribe((res) => {
            if (res.success === true && res.data.userOtp) {
                window.open(`${mainMenuBtnLink}${+(res.data.userOtp)}&profileType=${productType}&productId=${productId}`, "_blank");
            }
        }, (error: any) => {
            this.messageService.add({ key: 'tc', severity: 'error', summary: 'Error', detail: 'Failed to retrieve user data' });
        });
    }
}
